import React from 'react';
import { ArrowRight } from 'lucide-react';

// A compact, reusable conversion point. Dropped in at natural decision
// points down the page (after a section that's just made the case for
// something) rather than only living in the hero and footer.
const CtaBanner = ({ heading, subtext }) => {
  const scrollToContact = () => {
    const contactElement = document.querySelector('#contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="dark-full-container" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
      <div className="dark-content-container">
        <div
          className="reveal"
          style={{
            background: 'var(--gradient-brand-soft)',
            border: '1px solid var(--border-subtle)',
            borderRadius: '12px',
            padding: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '32px',
            flexWrap: 'wrap'
          }}
        >
          <div style={{ maxWidth: '560px' }}>
            <h3 className="heading-1" style={{ marginBottom: '8px' }}>
              {heading}
            </h3>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              {subtext}
            </p>
          </div>
          <button className="btn-primary" onClick={scrollToContact}>
            Get Started Now
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
